import React from "react";

function DeniedPage() {
  return (
    <div className="denied-container">
      <div className="denied-box">
        <h1>🔒 Acceso Denegado</h1>

        <p>No tenés permiso para acceder a este recurso.</p>
        <a href="/" className="back-link">
          Volver al inicio
        </a>
      </div>
    </div>
  );
}

export default DeniedPage;
